module.exports = __webpack_public_path__ + "img/Phillip Pettus.24cf1ab8.jpg";